export { default as useLifestyleStyles } from './useLifestyleStyles';
